
<Tailwind/>

<div class="whitespace-pre-line font-brown grid grid-auto-rows gap-y-4 p-5 w-80">
  <h1 class="font-brown">{$_('byPhone.continueOnPhone')}</h1>

    <div class="m-auto grid w-40 h-40">
  {#await sumsubToken}


    <div in:fade class="min-w-min m-auto">
<SyncLoader size="60" color="#FAE264" unit="px" duration="1s" />
    </div>
    
  {:then token}


    <div transition:fade>
      <QrCode color="#FFFFFF" background="#262626" value={`https://gambit.ai/#/sumsub/${token}`}/>
    </div>


  {/await}
    </div>
  <h2>{$_('byPhone.or')}</h2>

  <button class="bg-gambit grid grid-cols-3 text-black text-xl w-38 p-2 text-left hover:scale-105 transition-all" on:click={() => {$sessionData.sumsubHidden = false}}>
    <span class="text-xl col-span-2 text-black">{$_('byPhone.continueOnWeb')}</span>
    <img class="h-8 m-auto" src="monitor.svg" alt="">

  </button>
  <h4 class="text-xs font-autoscape text-gray">{$_('byPhone.disclaimer')}</h4>

</div>



<script>
  import {sessionData} from '../stores.js'
  import {getSumsubAccessToken, launchWebSdk, launchSumsub} from '../sumsub.js'
  import {onMount} from 'svelte'
  import {_} from 'svelte-i18n'
  import {fade} from 'svelte/transition'
	import { SyncLoader } from 'svelte-loading-spinners';
  import Tailwind from '../Tailwind.svelte';
  import QrCode from 'svelte-qrcode'

function later(delay) {
    return new Promise(function(resolve) {
        setTimeout(resolve, delay);
    });
}


  let sumsubToken = getSumsubAccessToken()

  onMount(async () => {

    const tok = await sumsubToken
    launchWebSdk(tok)

  })








</script>


